import './SlideLogo.css';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import screenfull from 'screenfull';

class SlideLogo extends Component {
  constructor(props) {
    super(props);
    this.el = React.createRef();
    this.onClick = () => {
      if (screenfull.enabled) {
        screenfull.toggle();
      }
    };
  }

  componentDidMount() {
    this.el.current.addEventListener('click', this.onClick, false);
  }

  componentWillUnmount() {
    this.el.current.removeEventListener('click', this.onClick);
  }

  render() {
    return (
      <img className="SlideLogo" src={this.props.src} ref={this.el} />
    );
  }
}

SlideLogo.propTypes = {
  src: PropTypes.string,
};

export default SlideLogo;
